import { environment } from './../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { UsuarioEntry } from 'src/app/shared/entrys/usuario.entry';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { retry, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PrestadorEntry } from 'src/app/shared/entrys/prestador.entry';
import { ActividadEconomicaEntry } from 'src/app/shared/entrys/actividad-economica.entry';
import { AuthService } from 'src/app/shared/services/auth.service';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class PerfilService implements RequestCRUD<PrestadorEntry, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private authService: AuthService, private enviromentGlobalService: EnviromentGlobalService) {
		this.handleError = httpErrorHandler.createHandleError('PerfilService');
		this.API_URL = enviromentGlobalService.apiUrl;
	}
	get(entry: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/perfil/${entry}`).pipe(
			retry(2)
		);
	}
	update(entry: PrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/perfil/${this.authService.getUserNameToken()}`, entry).pipe(
			retry(2)
		);
	}

	updateCambiarClave(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/usuario/CambiarClavePerfil`, entry).pipe(
			retry(2)
		);
	}

	create(entry: PrestadorEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	delete(entry: PrestadorEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	getActividadesEconomicas(entry: ActividadEconomicaEntry): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/ActividadEconomicaPrestador/PorUsuario`).pipe(
			retry(2)
		);
	}
}
